import React from "react";

function DownRightIcon() {
    return (
        <svg
            width="21"
            height="24"
            viewBox="0 0 21 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.6968 16.9949L13.8732 23.701C13.4677 24.1 12.8113 24.099 12.4059 23.7021C12.0004 23.3051 12.0004 22.6609 12.4048 22.2619L17.4717 17.2829H7.08284C3.1899 17.2829 0.0135165 14.1746 0 10.3508L0 1.01776C0 0.454927 0.463526 0 1.037 0C1.61047 0 2.074 0.454927 2.074 1.01776L2.074 10.3477C2.08331 13.0499 4.33054 15.2473 7.0828 15.2473L17.4509 15.2473L12.4038 10.2877C11.9993 9.88872 11.9993 9.24545 12.4048 8.84752C12.607 8.65008 12.8725 8.55033 13.138 8.55033C13.4035 8.55033 13.67 8.65008 13.8722 8.84855L20.6958 15.5557C21.1012 15.9537 21.1012 16.5979 20.6968 16.9949Z"
                fill="#B5B9BD"
            />
        </svg>
    );
}

export default DownRightIcon;
